import React from 'react'

const SideNav = () => {
  return (
    <div>
      <div className="service-sidebar">
                  <div className="service-catagery-list wow fadeInUp">
                    <h3>Interior Design</h3>
                    <ul>
                      <li><a className="nav-link" href="kitchen-designs">Kitchen Designs</a></li>
                      <li><a className="nav-link" href="bedroom-designs">Bedroom Designs</a></li>
                      <li><a className="nav-link" href="dining-room-designs">Dining Room Designs</a></li>
                      <li><a className="nav-link" href="living-room-designs">Living Room Designs</a></li>
                      <li><a className="nav-link" href="decorative-units-designs">Decorative Units Designs</a></li>
                      <li><a className="nav-link" href="kids-room-designs">Kids Room Designs</a></li>
                    </ul>
                  </div>

                  <div className="service-catagery-list wow fadeInUp">
                    <h3>Explore Designs</h3>
                    <ul>
                      <li><a className="nav-link" href="one-bhk-interior-designs">1 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="two-bhkinterior-designs">2 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="three-bhk-interior-designs">3 BHK Interior Designs</a></li>
                    </ul>
                  </div>

                  <div className="service-catagery-list wow fadeInUp">
                    <h3>MeHome Ideas</h3>
                    <ul>
                      <li><a className="nav-link" href="outdoor-designs">Outdoor Designs</a></li>
                      <li><a className="nav-link" href="landscape-designs">Landscape Designs</a></li>
                      <li><a className="nav-link" href="furniture-designs">Furniture Designs</a></li>
                    </ul>
                  </div>

                  <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.2s">
                    <div className="sidebar-cta-image">
                      <div className="image-anime">
                        <img src="imgs/contact-us.jpg" alt="" />
                      </div>
                    </div>

                    <div className="sidebar-cta-Body">
                      <div className="sidebar-cta-content">
                        <h3>how can we help</h3>
                        <p>If you need any helps, please feel free to contact us.</p>
                      </div>

                      <div className="sidebar-cta-contact">
                        <div className="sidebar-cta-contact-item">
                          <div className="icon-box">
                            <img src="images/icon-phone.svg" alt="" />
                          </div>
                          <div className="cta-contact-item-content">
                            <p>+91 9550 278 055</p>
                          </div>
                        </div>

                        <div className="sidebar-cta-contact-item">
                          <div className="icon-box">
                            <img src="images/icon-mail.svg" alt="" />
                          </div>
                          <div className="cta-contact-item-content">
                            <p>info@mehome.co.in</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
    </div>
  )
}

export default SideNav
